/* eslint max-lines: off */
// TODO: Refactor this file
import { track } from "jiffy-analytics";
// eslint-disable-next-line import/no-cycle
import { loadReviewsWithContext } from "components/jiffy/reviews-list/reviews-list";
import { on as onEvent } from "common/utils/ui/event";
import "./product-reviews-controls.scss";

// Getters
const $getWrapper = () => document.querySelector(".js-product-reviews-controls");
const $getForm = () => $getWrapper().querySelector(".js-review-search-form");
const $getInput = () => $getForm().querySelector(".js-review-search-input");
const $getControl = () => $getWrapper().querySelector(".js-product-w-reviews-img");
const $getReviewsSorting = () => $getWrapper().querySelector(".js-pdp-product-reviews-control");
const $getProductForm = () => document.querySelector(".js-product-details-quantity-form-product");
const $getActiveColor = () => document.getElementById("active-color-name");
const $getProductDetails = () => {
  const activeColor = $getActiveColor();
  if (!activeColor) return null;
  return document.querySelector(
    `#product-details-variants-form input[data-color="${CSS.escape(activeColor.value)}"]`
  );
};
const $getProductHeaderDetail = () => document.querySelector(".product-details-header");
const $getReviewRatingStar = rate => document.querySelector(`.js-review-rating-star-${rate}`);
const $getProductFeedbackReviewCount = () =>
  $getProductHeaderDetail().querySelector(".js-product-feedback-review-count");
const $getRecommendedFeedback = () =>
  $getProductHeaderDetail().querySelector(".js-product-details-recommended-feedback");
const $getReviewRatingAvg = () => $getProductHeaderDetail().querySelector(".js-review-rating-avg");
const $getMadeReviewContainer = () =>
  $getProductHeaderDetail().querySelector(".js-made-pdp-reviews");
const $getPointPopover = () =>
  $getProductHeaderDetail()?.querySelector(".product-details-user-feedback__point-popover");
const getQuery = () => $getInput().value;
const isReviewsWithImages = () => $getControl()?.checked;
const getReviewSortingText = () => {
  const $sorting = $getReviewsSorting();
  return $sorting.options[$sorting.selectedIndex].text;
};

const trackEvent = (event, params) => {
  const productDetails = $getProductDetails();
  if (!$getActiveColor() || !productDetails) return;
  const { detailedProductName, compositionId, catalogNumber, color, businessLine } =
    productDetails.dataset ?? {};

  track(event, {
    ...params,
    page: window.location.href,
    name: detailedProductName,
    composition: color,
    spree_composition_id: compositionId,
    catalog_number: catalogNumber,
    product_id: $getProductForm()?.value,
    business_line: businessLine
  });
};

const getStar = star => parseInt($getReviewRatingStar(star).dataset.percentage, 10) || 0;

const trackEventCustomerFeedback = (event, additionalData = {}) => {
  if (!$getProductHeaderDetail()) return;

  trackEvent(event, {
    ...additionalData,
    five_stars_percentage: getStar(5),
    four_stars_percentage: getStar(4),
    three_stars_percentage: getStar(3),
    two_stars_percentage: getStar(2),
    one_stars_percentage: getStar(1),
    total_number_of_reviews:
      parseInt($getProductFeedbackReviewCount()?.dataset.reviewCount, 10) || 0,
    recommend_percentage: recommendPercentage(),
    total_rating: averageRating()
  });
};

const recommendPercentage = () => {
  const { businessLine } = $getProductDetails()?.dataset ?? {};

  const $dataElement =
    businessLine === "Print" ? $getMadeReviewContainer() : $getRecommendedFeedback();

  return parseInt($dataElement?.dataset.recommendRatio, 10) || 0;
};

const averageRating = () => {
  const { businessLine } = $getProductDetails()?.dataset ?? {};

  const $dataElement = businessLine === "Print" ? $getMadeReviewContainer() : $getReviewRatingAvg();

  return parseFloat($dataElement?.dataset.ratingAvg) || 0;
};

// Check if we're on the dedicated reviews page vs PDP
const isOnDedicatedReviewsPage = () => window.location.pathname.includes("/reviews");

// Redirect to dedicated reviews page with current filters
const redirectToReviewsPage = () => {
  const { reviewsPath } = $getWrapper().dataset;
  const { reviewsAnchor } = $getWrapper().dataset;
  const params = new URLSearchParams();

  // Add current filter parameters
  Object.keys(window.reviews || {}).forEach(key => {
    if (key === "customizations" && Array.isArray(window.reviews[key])) {
      window.reviews[key].forEach(value => params.append("customizations[]", value));
    } else if (window.reviews[key]) {
      params.set(key, window.reviews[key]);
    }
  });

  // Build URL with proper query params and anchor
  let url = reviewsPath;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  if (reviewsAnchor) {
    url += `#${reviewsAnchor}`;
  }

  window.location.href = url;
};

const onChangeFilter = $control => {
  const { name } = $control.dataset;

  if ($control.checked || $control.checked === undefined) {
    window.reviews[name] = `${$control.value}`;
  } else {
    delete window.reviews[name];
  }
  window.reviews.page = 1;

  // If on PDP, redirect to dedicated reviews page
  // If already on reviews page, load via AJAX
  if (isOnDedicatedReviewsPage()) {
    loadReviewsWithContext();
  } else {
    redirectToReviewsPage();
  }
};

const initProductReviewsSearch = () => {
  const onChange = e => {
    e.preventDefault();
    window.reviews.search = getQuery();
    window.reviews.page = 1;

    // If on PDP, redirect to dedicated reviews page
    // If already on reviews page, load via AJAX
    if (isOnDedicatedReviewsPage()) {
      loadReviewsWithContext();
    } else {
      redirectToReviewsPage();
    }

    trackEvent("pdp_reviews_search_clicked", {
      query: window.reviews.search,
      reviews_with_images: isReviewsWithImages(),
      reviews_sorting: getReviewSortingText(),
      review_customizations_list: window.reviews.customizations
    });
  };

  onEvent("submit", ".js-review-search-form", onChange, true);
};

const initReviewsEvents = () => {
  const onChange = ({ target: $control }) => {
    onChangeFilter($control);

    trackEvent("pdp_reviews_with_images_link_reviews_click", {
      review_search_string: getQuery(),
      reviews_sorting: getReviewSortingText(),
      reviews_with_images: $control.checked,
      review_customizations_list: window.reviews.customizations
    });
  };

  onEvent("change", ".js-product-w-reviews-img", onChange, true);
};

const initResultsSortingOptionsEvents = () => {
  let prevReviewsSorting = getReviewSortingText();
  const onChange = ({ target: $control }) => {
    const currentChange = $control.options[$control.selectedIndex].text;

    onChangeFilter($control);
    trackEvent("pdp_reviews_sorting_changed", {
      review_search_string: getQuery(),
      reviews_sorting: currentChange,
      previous_reviews_sorting: prevReviewsSorting,
      reviews_with_images: isReviewsWithImages(),
      review_customizations_list: window.reviews.customizations
    });
    prevReviewsSorting = currentChange;
  };

  onEvent("change", ".js-pdp-product-reviews-control", onChange, true);
};

const initCustomizationEvents = () => {
  const onChange = ({ target: $target }) => {
    if (!window.reviews.customizations) window.reviews.customizations = [];

    if ($target.checked) {
      window.reviews.customizations.push($target.value);
    } else {
      window.reviews.customizations = window.reviews.customizations.filter(
        id => id !== $target.value
      );
    }

    window.reviews.page = 1;

    // If on PDP, redirect to dedicated reviews page
    // If already on reviews page, load via AJAX
    if (isOnDedicatedReviewsPage()) {
      loadReviewsWithContext();
    } else {
      redirectToReviewsPage();
    }

    trackEvent("pdp_reviews_customization_filter_clicked", {
      review_customizations_list: window.reviews.customizations,
      reviews_sorting: getReviewSortingText(),
      review_search_string: getQuery(),
      reviews_with_images: isReviewsWithImages()
    });
  };

  onEvent("click", ".js-review-customization", onChange, true);
};

const initTrackCustomerReviews = () => {
  const onChange = ({ target: $target }) => {
    const { label } = $target.closest(".js-feedback-label-tracker").dataset;
    trackEventCustomerFeedback("product_detail_review_link_clicked", { text: label });
  };

  onEvent("click", ".js-feedback-label-tracker", onChange, true);
};

const initSeeAllCustomerReview = () => {
  const callback = () => {
    trackEventCustomerFeedback("see_all_customer_reviews_clicked", {
      review_search_string: getQuery(),
      reviews_sorting: getReviewSortingText(),
      reviews_with_images: isReviewsWithImages(),
      review_customizations_list: window.reviews.customizations
    });
  };

  onEvent("click", ".js-see-review-rating-link", callback, true);
};

const initCustomerReviewPopover = () => {
  if (!$getPointPopover()) return;

  let eventCount = 0;
  const style = window.getComputedStyle($getPointPopover());
  const callback = () => {
    if (eventCount < 10 && style.opacity < 1) {
      trackEventCustomerFeedback("product_detail_review_star_dropdown_open");
      eventCount += 1;
    }
  };
  onEvent("mouseenter", ".js-top-rating-stars", callback, true);
};

const initTrackReviewDetailsToggle = () => {
  const callbackShow = ({ target: $target }) => {
    const { action } = $target.closest(".js-reviews-list-item-track").dataset;
    const { reviewId } = $target.closest(".js-review-list-item")?.dataset || {};
    trackEvent("product_detail_review_detail_toggle", {
      action,
      review_id: reviewId
    });
  };

  onEvent("click", ".js-reviews-list-item-track", callbackShow, true);
};

const initTrackReviewHelpfulness = () => {
  const callback = ({ target: $target }) => {
    const { action } = $target.dataset;
    const { reviewId } = $target.closest(".js-review-list-item")?.dataset || {};
    trackEvent("product_detail_answer_review_helpfulness", {
      action,
      review_id: reviewId
    });
  };

  onEvent("click", ".js-reviews-list-item__vote-action-button", callback, true);
};

export default () => {
  if (!$getWrapper()) return;
  window.reviews = window.reviews || {};

  initProductReviewsSearch();
  initReviewsEvents();
  initResultsSortingOptionsEvents();
  initTrackCustomerReviews();
  initSeeAllCustomerReview();
  initCustomerReviewPopover();
  initTrackReviewDetailsToggle();
  initTrackReviewHelpfulness();
  initCustomizationEvents();
};
